import {Component, OnInit, Renderer2, RendererStyleFlags2} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {NavigationEnd, Router} from '@angular/router';
import {Location} from "@angular/common";

@Component({
  selector: 'app-intercom',
  templateUrl: './intercom.component.html',
  styleUrls: ['./intercom.component.scss']
})
export class IntercomComponent implements OnInit {

  otpTimerInterval: any

  constructor(
    private renderer: Renderer2,
  ) {
  }

  ngOnInit(): void {
    const intercomContainer = document.getElementById("intercom-container");

      this.otpTimerInterval = setInterval(() => {
        const intercomContainer = document.getElementById("intercom-frame");
        if (intercomContainer) {
          // @ts-ignore
          window.Intercom('show');
          clearInterval(this.otpTimerInterval);
        }
      }, 1000);

    setTimeout(() => {
      // @ts-ignore
      if (window.Intercom) {
        // @ts-ignore
        window.Intercom('onHide', this.intercomChatClosedCallback);
      }
    }, 5000)
  }
  private intercomChatClosedCallback = () => {
    window.location.href =  window.location.origin
  };
  ngOnDestroy() {
    // @ts-ignore
    if (window.Intercom) {
      // @ts-ignore
      window.Intercom('onHide', null);
    }
  }
}
